<script setup lang="ts">
import Icon from '~/assets/images/icons/camera.svg'

defineProps<{
  size: number
}>()
</script>

<template>
  <Icon fill="#000" :height="size" :width="size" />
</template>
